import React from 'react';
import PropTypes from 'prop-types';

export function Content(props) {
  return <p className={props.className}>{props.text}</p>;
}

Content.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Text to display as content
   */
  text: PropTypes.string,
};

Content.defaultProps = {
  className: '',
};
